import moment from 'moment-timezone';

const DELAY_THRESHOLD_MS = 4 * 60 * 60 * 1000;

export function getReadingReceipt(measuredAt, backendTimestamp) {
  if (!backendTimestamp) return null;
  const receivedAt = moment(backendTimestamp, moment.ISO_8601, true);
  if (!receivedAt.isValid()) return null;
  const measured = measuredAt
    ? (typeof measuredAt === 'string' ? moment(measuredAt, moment.ISO_8601, true) : moment(measuredAt))
    : null;
  return {
    receivedAt,
    delayed: Boolean(measured?.isValid() && receivedAt.valueOf() - measured.valueOf() >= DELAY_THRESHOLD_MS),
  };
}

export function latestReceipt(first, second) {
  const a = getReadingReceipt(null, first);
  const b = getReadingReceipt(null, second);
  if (!a) return b ? second : null;
  if (!b) return first;
  return a.receivedAt.valueOf() >= b.receivedAt.valueOf() ? first : second;
}

export function formatReadingReceipt(receivedAt, displayReference, displayFormat) {
  const date = receivedAt.clone();
  const reference = moment.isMoment(displayReference)
    ? displayReference
    : (displayReference ? moment(displayReference, moment.ISO_8601, true) : null);
  if (reference?.isValid()) {
    const timezone = reference.tz();
    if (timezone) date.tz(timezone);
    else if (reference.isUTC()) date.utc();
    else if (reference.isLocal()) date.local();
    else date.utcOffset(reference.utcOffset());
  }
  return date.format(displayFormat);
}
